<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="hdTaskStoreService.getState?.requiredFields?.client">
          Клиент
        </label>
        <crm-client-auto-complete
          [(selectedClient)]="form.client"
          (selectedClientChange)="changeClient()"
          [isError]="$any(errors?.client)"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client }}
        </small>
      </div>

      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="hdTaskStoreService.getState?.requiredFields?.externalUser">
          Внешний пользователь
        </label>
        <div class="flex align-items-center gap-1">
          <div class="flex-grow-1">
            <crm-external-user-single-select
              [clientId]="form.client?.id"
              [(selectedExternalUser)]="form.externalUser"
              [isError]="$any(errors?.externalUser)"
              appendTo="body">
            </crm-external-user-single-select>
          </div>

          <p-button
            *ngIf="form.client?.id"
            icon="pi pi-plus"
            (click)="openFormCreateExternalUser()"></p-button>
        </div>
        <small
          *ngIf="errors?.externalUser"
          class="p-error">
          {{ errors.externalUser }}
        </small>
      </div>

      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="hdTaskStoreService.getState?.requiredFields?.taskType">
          Тип заявки
        </label>
        <crm-hd-task-type-single-select
          [customRequest]="true"
          [taskTypes]="filters.taskTypes"
          [(selectedTaskType)]="form.taskType"
          [showClear]="true"
          [styleClass]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
          [class]="errors?.taskType ? 'ng-invalid ng-dirty' : ''"
          appendTo="body">
        </crm-hd-task-type-single-select>
        <small
          *ngIf="errors?.taskType"
          class="p-error">
          {{ errors.taskType }}
        </small>
      </div>

      <div class="field">
        <label
          class="font-medium"
          [class.required-field]="hdTaskStoreService.getState?.requiredFields?.unit">
          Бизнес единица
        </label>
        <crm-unit-single-select
          [(selectedUnit)]="form.unit"
          [showClear]="true"
          [isError]="$any(errors?.unit)"
          appendTo="body"></crm-unit-single-select>
        <small
          *ngIf="errors?.unit"
          class="p-error">
          {{ errors.unit }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <button
      pButton
      label="Принять"
      icon="pi pi-check"
      class="p-button-success"
      (click)="acceptTask()"></button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
